var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seviceErr"
  }, [_c('im-top'), _vm._v(" "), _c('img', {
    staticClass: "errImg",
    attrs: {
      "src": _vm.imgUrl + 'im_err.png',
      "alt": "服务器忙"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("您使用浏览器版本太低，请更换浏览器后再访问")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0237a410","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/beatis.vue
// module id = +p5I
// module chunks = 1